<div class="oopsOuter">
  <div class="oops ColorBlue">OOPS!</div>
  <div class="error ColorRed">Error 404 : Page not found</div>
</div>
